(function() {
  class CustomProductCard {
    constructor() {
      this.variantButtons = document.querySelectorAll('.custom-card__button--variant');
      this.cartButtons = document.querySelectorAll('.custom-card__button--cart');
      this.variantPopups = document.querySelectorAll('.variant-selector-popup');
      this.variantForms = document.querySelectorAll('[id^="VariantForm-"]');
      this.closeButtons = document.querySelectorAll('.variant-selector-popup__close');
      this.init();
    }

    init() {
      this.variantButtons.forEach(b => b.addEventListener('click', this.openVariantPopup.bind(this)));
      this.cartButtons.forEach(b => b.addEventListener('click', this.addToCart.bind(this)));
      this.closeButtons.forEach(b => b.addEventListener('click', this.closeVariantPopup.bind(this)));

      this.variantForms.forEach(form => {
        form.addEventListener('submit', this.handleVariantFormSubmit.bind(this));
        form.querySelectorAll('.variant-selector-popup__option-input').forEach(input => {
          input.addEventListener('change', this.updateVariantInfo.bind(this, form));
        });
        this.updateVariantInfo(form);
      });

      // click-outside + esc handled as you had
      window.addEventListener('click', (e) => {
        this.variantPopups.forEach(popup => { if (e.target === popup) this.closePopup(popup); });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.variantPopups.forEach(p => p.open && this.closePopup(p));
      });
    }

    openVariantPopup(event) {
      const button = event.currentTarget;
      const productId = button.getAttribute('data-product-id');
      const popup = document.getElementById(`VariantModal-${productId}`);
      if (popup) popup.showModal();
    }

    closeVariantPopup(event) {
      const popup = event.currentTarget.closest('.variant-selector-popup');
      this.closePopup(popup);
    }

    closePopup(popup) {
      if (popup && popup.open) popup.close();
    }

    async updateVariantInfo(form) {
      // 🔁 use handle
      const productHandle = form.querySelector('input[name="product_handle"]')?.value;
      if (!productHandle) return;

      const options = {};
      form.querySelectorAll('.variant-selector-popup__option-input:checked').forEach(input => {
        const name = input.getAttribute('name'); // expects option1/option2/option3
        options[name] = input.value;
      });

      const variantId = await this.getVariantId(productHandle, options);
      if (!variantId) return;

      // If you really need a snippet response, make sure this section exists. Otherwise, skip this fetch.
      try {
        const response = await fetch(`/products/${productHandle}?variant=${variantId}&section_id=api-product-data`);
        if (!response.ok) return;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const priceHTML = doc.querySelector('.price')?.innerHTML;
        const availHTML = doc.querySelector('.availability')?.innerHTML;

        const container = form.closest('.variant-selector-popup');
        if (priceHTML) container.querySelector('.variant-selector-popup__price')?.replaceChildren(...this.htmlToNodes(priceHTML));
        if (availHTML) container.querySelector('.variant-selector-popup__availability')?.replaceChildren(...this.htmlToNodes(availHTML));
      } catch (e) {
        // silent fail okay
      }
    }

    htmlToNodes(html) {
      const tpl = document.createElement('template');
      tpl.innerHTML = html.trim();
      return Array.from(tpl.content.childNodes);
    }

    handleVariantFormSubmit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const productHandle = form.querySelector('input[name="product_handle"]')?.value;
      if (!productHandle) {
        alert('Product not found');
        return;
      }

      const formData = new FormData(form);
      const options = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('option')) options[key] = value; // option1/2/3
      }

      this.getVariantId(productHandle, options)
        .then(variantId => {
          if (variantId) {
            this.addToCartById(variantId, 1);
            this.closePopup(form.closest('.variant-selector-popup'));
          } else {
            alert('Could not find the selected variant. Please try a different combination.');
          }
        })
        .catch(err => {
          console.error('Error adding product to cart:', err);
          alert('Error adding product to cart. Please try again.');
        });
    }

    // 🔁 Accepts HANDLE
    async getVariantId(productHandle, selectedOptions) {
      try {
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) throw new Error(`Failed to fetch product: ${response.statusText}`);
        const product = await response.json();

        // Map option1/2/3 -> array positions
        const optionSelections = {};
        for (const [key, value] of Object.entries(selectedOptions)) {
          const pos = parseInt(key.replace('option', ''), 10);
          optionSelections[pos] = value;
        }

        const match = product.variants.find(variant => {
          // variant.options is an array [opt1, opt2, opt3]
          return Object.entries(optionSelections).every(([pos, val]) => variant.options[pos - 1] === val);
        });

        return match ? match.id : null;
      } catch (err) {
        console.error('Error fetching product data:', err);
        return null;
      }
    }

    addToCart(event) {
      event.preventDefault();
      const button = event.currentTarget;
      const card = button.closest('.custom-card');

      // Prefer DOM-provided variant (select/hidden), else fallback to first available
      const variantId = this.getVariantIdFromCard(card) || button.getAttribute('data-variant-id');
      if (variantId) {
        this.addToCartById(variantId, 1);
        return;
      }

      // If there’s a variant modal for this card, open it; otherwise fallback
      const productId = card?.dataset.productId;
      const modal = document.getElementById(`VariantModal-${productId}`);
      if (modal) {
        this.openVariantPopup({ currentTarget: button });
        return;
      }

      // Fallback: first available using handle
      const handle = card?.dataset.productHandle;
      if (!handle) {
        console.error('No product handle on card');
        return;
      }
      this.getFirstVariantId(handle).then(id => {
        if (id) this.addToCartById(id, 1);
        else alert('Could not find a valid variant for this product');
      });
    }

    getVariantIdFromCard(card) {
      if (!card) return null;
      // select in card
      const select = card.querySelector('.custom-card__variant-select');
      if (select?.value) return select.value;
      // hidden input (single variant)
      const hidden = card.querySelector('.custom-card__variant-hidden');
      if (hidden?.value) return hidden.value;
      // fallback data-first-available
      if (card.dataset.firstAvailable) return card.dataset.firstAvailable;
      return null;
    }

    // 🔁 Accepts HANDLE
    async getFirstVariantId(productHandle) {
      try {
        const res = await fetch(`/products/${productHandle}.js`);
        if (!res.ok) throw new Error(`Failed to fetch product: ${res.statusText}`);
        const product = await res.json();
        const v = product.variants.find(v => v.available) || product.variants[0];
        return v ? v.id : null;
      } catch (e) {
        console.error('Error fetching product data:', e);
        return null;
      }
    }

    async addToCartById(variantId, quantity) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
        });

        if (!response.ok) {
          const err = await response.json();
          console.error('Error response from cart/add.js:', err);
          alert(`Error adding to cart: ${err.description || 'Please try again'}`);
          return;
        }

        const result = await response.json();
        console.log('Successfully added to cart:', result);
        this.showAddedToCartFeedback();
        this.updateMiniCart();
      } catch (e) {
        console.error('Exception when adding to cart:', e);
        alert('Error adding to cart. Please try again.');
      }
    }

    showAddedToCartFeedback() {
      const n = document.createElement('div');
      n.className = 'add-to-cart-notification';
      n.textContent = 'Added to cart!';
      document.body.appendChild(n);
      setTimeout(() => {
        n.classList.add('show');
        setTimeout(() => {
          n.classList.remove('show');
          setTimeout(() => n.remove(), 300);
        }, 2000);
      }, 10);
    }

    async updateMiniCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        document.querySelectorAll('.cart-count-bubble').forEach(el => {
          el.textContent = cart.item_count;
          el.classList.toggle('hide', cart.item_count === 0);
        });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) {
        console.error('Error updating cart:', e);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CustomProductCard();
    const style = document.createElement('style');
    style.textContent = `
      .add-to-cart-notification {
        position: fixed; bottom: 20px; right: 20px;
        background-color: #B19F6D; color: white; padding: 15px 20px;
        border-radius: 4px; box-shadow: 0 4px 12px rgba(0,0,0,.15);
        transform: translateY(100px); opacity: 0; transition: transform .3s, opacity .3s; z-index: 9999;
      }
      .add-to-cart-notification.show { transform: translateY(0); opacity: 1; }
    `;
    document.head.appendChild(style);
  });
})();
